import request from "@/utils/request";
import qs from "qs"
//获取职位
export const getJobList = (data = {}) => {
    /*
    * type 类型
    * size 数目
    * */
    return request({
        url: "/job/test-getTree",
        data,
    })
}

//获取职位
export const getPositionList = (data = {}) => {
    /*
    * size  查询条数
    "type":1,
    "title":关键字
    "address":工作地点
    "id":[], 搜索详情
    "jobId":[1234], 搜索岗位列表 ，和id不能同时存在
    "currentPage":0 当前页
    * */
    return request({
        url: "/job/test-getPosition",
        data,
    })
}
//获取职位
export const sendJanli = (data = {}) => {
    /*
    * resume  简历地址
     contact 联系方式
    "pid" ,
    name：姓名
    * */
    return request({
        url: "/job/insertOfRecruit",
        data: qs.stringify(data),
    })
}
